/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S7_P2_EmInputs */

const tr_mesafeli_s7_p2_em = /** @type {(inputs: Mesafeli_S7_P2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cayma hakkı süresi sona ermeden önce Tüketicinin onayı ile ifasına başlanan hizmetlere ilişkin sözleşmelerde cayma hakkı kullanılamaz`)
};

const en_mesafeli_s7_p2_em = /** @type {(inputs: Mesafeli_S7_P2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in contracts for services whose performance has begun, with the consent of the Consumer, before the withdrawal period expires, the right of withdrawal cannot be exercised`)
};

const de_mesafeli_s7_p2_em = /** @type {(inputs: Mesafeli_S7_P2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bei Verträgen über Dienstleistungen, mit deren Erbringung vor Ablauf der Widerrufsfrist mit Zustimmung des Verbrauchers begonnen wurde, kann das Widerrufsrecht nicht ausgeübt werden`)
};

const ru_mesafeli_s7_p2_em = /** @type {(inputs: Mesafeli_S7_P2_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`по договорам об услугах, исполнение которых начато с согласия Потребителя до истечения срока на отказ, право на отказ от договора не может быть использовано`)
};

/**
* | output |
* | --- |
* | "in contracts for services whose performance has begun, with the consent of the Consumer, before the withdrawal period expires, the right of withdrawal cannot..." |
*
* @param {Mesafeli_S7_P2_EmInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s7_p2_em = /** @type {((inputs?: Mesafeli_S7_P2_EmInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S7_P2_EmInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s7_p2_em(inputs)
	if (locale === "de") return de_mesafeli_s7_p2_em(inputs)
	if (locale === "ru") return ru_mesafeli_s7_p2_em(inputs)
	return tr_mesafeli_s7_p2_em(inputs)
});